import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { AuthProvider } from 'react-oidc-context';
import { ToastContainer } from 'react-toastify';

import { env } from '@/app/conf/env';
import { oidcConfig } from '@/app/lib/react-oidc-context';
import { queryClient } from '@/app/lib/tanstack-query';
import { Spinner } from '@/common/components/spinner';
import { RootErrorFallback } from '@/shared/components/root-error-fallback';

export function AppProvider({ children }: { children: React.ReactNode }) {
  return (
    <React.Suspense
      fallback={(
        <div className="flex h-screen items-center justify-center">
          <Spinner size="xl" />
          <p className="text-center text-zinc-950/50">Loading...</p>
        </div>
      )}
    >
      <AuthProvider {...oidcConfig}>
        <ErrorBoundary FallbackComponent={RootErrorFallback}>
          <QueryClientProvider client={queryClient}>
            {env.DEBUG_TANSTACK_QUERY && (<ReactQueryDevtools />)}
            {env.DEBUG_TANSTACK_ROUTER && (<TanStackRouterDevtools />)}
            {children}
            <ToastContainer />
          </QueryClientProvider>
        </ErrorBoundary>
      </AuthProvider>
    </React.Suspense>
  );
}
